<h4 class="selenium-curriculum-header">
    Explore related topics <app-icon [type]="'External-link'"></app-icon>
</h4>
<div class="curriculum-tags selenium-curriculum-tags d-flex flex-wrap">
    <app-link
        *ngFor="let tag of curriculumTags"
        [href]="tag.browseLink"
        [target]="'_blank'"
        class="curriculum-tag selenium-curriculum-tag gtm-curriculum-tag p-2"
        [ngClass]="[tag.colorClass, tag.levelClass, (isInPreviewMode$ | async) ? 'preview' : '']"
        [attr.data-gtmlabel]="tag.name"
    >
        {{ tag.name }}
    </app-link>
</div>
